import { render } from "./Tab.vue?vue&type=template&id=a8e8aeba&scoped=true&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=a8e8aeba&scoped=true&lang=scss"
import "./Tab.vue?vue&type=style&index=1&id=a8e8aeba&lang=scss"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e8aeba"]])

export default __exports__